import { render, staticRenderFns } from "./Vets.vue?vue&type=template&id=5ebfdc55&"
import script from "./Vets.vue?vue&type=script&lang=js&"
export * from "./Vets.vue?vue&type=script&lang=js&"
import style0 from "./Vets.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports